import React from 'react';
import { Eye } from 'lucide-react';
import Pagination from '../CardsView/Pagination';
import './TableView.css';

export default function TableView({ data, columns, onViewDetails, currentPage, totalPages, onPageChange }) {
  const formatValue = (value, columnHeader) => {
    if (!value || value === '-') return '-';
    
    // Detectar se é uma coluna de valor monetário
    const isValueColumn = columnHeader.toLowerCase().includes('valor') || 
                         columnHeader.toLowerCase().includes('vlr');
    
    if (isValueColumn) {
      // Converter valor americano para número
      const numericValue = parseFloat(String(value).replace(/[R$\s,]/g, ''));
      
      if (!isNaN(numericValue)) {
        // Formatar em Real brasileiro
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(numericValue);
      }
    }
    
    return value;
  };

  if (data.length === 0) {
    return (
      <div className="table-view-empty">
        <p>Nenhuma emenda encontrada</p>
      </div>
    );
  }

  return (
    <div className="table-view">
      <div className="table-view__wrapper">
        <table className="table-view__table">
          <thead>
            <tr>
              <th className="table-view__actions-header">Ações</th>
              {columns.map((column, index) => (
                <th key={index}>{column.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td className="table-view__actions-cell">
                  <button
                    onClick={() => onViewDetails(row)}
                    className="table-view__action-button"
                    aria-label="Ver detalhes da emenda"
                  >
                    <Eye className="w-4 h-4" />
                    <span>Ver Detalhes</span>
                  </button>
                </td>
                {columns.map((column, colIndex) => (
                  <td key={colIndex}>
                    {formatValue(row[column.accessorKey], column.header)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
}
